import React, { useRef } from 'react';
import { desgloseCarrito, fmt } from '../utils/igv';

export default function Receipt({ cart, settings, onClose, onNewSale }) {
  const printRef = useRef();
  const { subtotal, igv, total } = desgloseCarrito(cart);
  const [payment, setPayment] = React.useState('');
  const vuelto = payment && +payment >= total ? +payment - total : null;
  const num = String(Date.now()).slice(-6);
  const now = new Date().toLocaleString('es-PE', { dateStyle:'short', timeStyle:'short' });

  const handlePrint = () => {
    const html = printRef.current.innerHTML;
    const w = window.open('', '_blank', 'width=400,height=700');
    w.document.write(`<!DOCTYPE html><html><head><title>Comprobante</title>
    <style>
      *{margin:0;padding:0;box-sizing:border-box}
      body{font-family:'Courier New',monospace;font-size:12px;color:#000;padding:8px}
      .c{text-align:center}.b{font-weight:bold}.lg{font-size:16px}.sm{font-size:10px}
      .hr{border-top:1px dashed #000;margin:5px 0}
      .row{display:flex;justify-content:space-between;margin:2px 0}
      @media print{body{padding:0}}
    </style></head><body>${html}</body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => { w.print(); w.close(); }, 300);
  };

  return (
    <div style={S.overlay}>
      <div style={S.modal}>
        <div style={S.hdr}>
          <h3 style={{ fontSize:16, fontWeight:700 }}>Comprobante de venta</h3>
          <button style={S.xbtn} onClick={onClose}>✕</button>
        </div>

        {/* Efectivo input */}
        <div style={{ padding:'10px 16px 0', flexShrink:0 }}>
          <input
            style={S.payInp}
            type="number" step="0.50"
            placeholder="Efectivo recibido (opcional)"
            value={payment}
            onChange={e => setPayment(e.target.value)}
          />
          {vuelto !== null && (
            <p style={{ textAlign:'right', fontSize:14, fontWeight:700, color:'var(--teal)', marginTop:4 }}>
              Vuelto: {fmt(vuelto)}
            </p>
          )}
        </div>

        {/* Receipt preview */}
        <div style={S.body}>
          <div ref={printRef} style={S.paper}>
            <p className="c b lg">{settings?.store_name || 'MINIMARKET'}</p>
            <p className="c sm">{settings?.store_address || 'Arequipa, Perú'}</p>
            {settings?.ruc && <p className="c sm">RUC: {settings.ruc}</p>}
            <div className="hr"/>
            <p className="c sm">NOTA DE VENTA N° {num}</p>
            <p className="c sm">{now}</p>
            {settings?.cashier && <p className="c sm">Atendido por: {settings.cashier}</p>}
            <div className="hr"/>

            {/* Items */}
            {cart.map((it, i) => {
              const { subtotal: isub, igv: iigv } = desgloseCarrito([it]);
              return (
                <div key={i}>
                  <p style={{ fontSize:10 }}>{it.name}</p>
                  <div className="row" style={{ fontSize:10 }}>
                    <span style={{ flex:1, paddingLeft:6 }}>{fmt(it.price)} × {it.qty} {it.unit}</span>
                    <span>{fmt(it.price * it.qty)}</span>
                  </div>
                </div>
              );
            })}

            <div className="hr"/>
            {/* IGV breakdown - prices already include IGV */}
            <div className="row sm"><span>Op. gravadas (sin IGV):</span><span>{fmt(subtotal)}</span></div>
            <div className="row sm"><span>IGV 18%:</span><span>{fmt(igv)}</span></div>
            <div className="hr"/>
            <div className="row b" style={{ fontSize:14 }}><span>TOTAL:</span><span>{fmt(total)}</span></div>
            <div className="hr"/>

            {payment && (
              <>
                <div className="row sm"><span>Efectivo:</span><span>{fmt(+payment)}</span></div>
                <div className="row b sm"><span>Vuelto:</span><span>{fmt(vuelto ?? 0)}</span></div>
                <div className="hr"/>
              </>
            )}
            <p className="c sm" style={{ marginTop:6 }}>¡Gracias por su preferencia!</p>
            <p className="c sm">Vuelva pronto 🙏</p>
          </div>
        </div>

        <div style={S.footer}>
          <button style={S.newSaleBtn} onClick={onNewSale}>Nueva venta</button>
          <button style={S.printBtn} onClick={handlePrint}>🖨️ Imprimir</button>
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,.9)', display:'flex', alignItems:'center', padding:12, zIndex:200 },
  modal:   { background:'var(--bg1)', borderRadius:18, width:'100%', maxWidth:420, maxHeight:'96vh', display:'flex', flexDirection:'column' },
  hdr:     { display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', borderBottom:'0.5px solid var(--bd)', flexShrink:0 },
  xbtn:    { background:'var(--bg2)', color:'var(--t1)', border:'0.5px solid var(--bd)', borderRadius:7, padding:'4px 9px', fontSize:12 },
  payInp:  { width:'100%', background:'var(--bg2)', border:'0.5px solid var(--bd2)', borderRadius:9, padding:'9px 12px', color:'var(--t0)', fontSize:13 },
  body:    { overflowY:'auto', padding:'10px 12px', flex:1 },
  paper:   { background:'#fff', color:'#000', padding:'12px 10px', fontFamily:"'Courier New',monospace", fontSize:10, borderRadius:6, lineHeight:1.7 },
  footer:  { display:'flex', gap:10, padding:'10px 16px', borderTop:'0.5px solid var(--bd)', flexShrink:0 },
  newSaleBtn: { flex:1, background:'var(--bg2)', color:'var(--t1)', border:'0.5px solid var(--bd)', borderRadius:10, padding:'11px', fontSize:13, fontWeight:500 },
  printBtn:   { flex:2, background:'var(--acc)', color:'#fff', border:'none', borderRadius:10, padding:'11px', fontSize:14, fontWeight:700 },
};
